import React from 'react'
import {Link} from 'react-router-dom'

const Register = () => {
  return (
    <div className="min-h-full lg:bg-light-blue white-space-normal overflow-y-hidden">
    <div className=" bg-white lg:bg-light-blue  h-screen w-full grid place-items-center overflow-y-hidden pb-0  ">
    <div className="bg-white lg:shadow-lg rounded-lg w-full h-auto lg:w-96 p-6">
 {/* header */}
 <div className="flex flex-col justify-center items-center h-24 w-full ">
     <h1 className="font-poppins font-semi-bold text-2xl" >
     Create an Account
     </h1>
     <div className="underline" />
 </div>
 {/* Form */}
 <div className="flex flex-col justify-center items-start lg:flex-row lg:items-center  w-full lg:space-x-4 space-y-4 lg:space-y-0 ">
      <div className="flex flex-col   w-full lg:w-1/2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      First Name
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Firstname" />
        </div>
      <div className="flex flex-col   w-full lg:w-1/2 ">
      <label className="font-poppins font-medium text-base mb-2" >
      First Name
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Firstname" />
        </div>
        
   </div>
   {/* Email */}
   <div className="flex flex-col   w-full mt-2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      Email
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Email" />
        </div>
        {/* Password */}
        <div className="flex flex-col   w-full mt-2  ">
      <label className="font-poppins font-medium text-base mb-2" >
      Password
      </label>
      <input className="bg-light-blue  text-base px-4 py-2 focus:outline-none  w-full" type="text" placeholder="Password" />
        </div>
        {/* Terms and Condition */}
        <div className="flex flex-col   w-full mt-2  ">
          <p className="font-poppins font-medium text-gray text-tiny mb-2" >
          BY creating an account on Tradr. Shop you are agreeing <br/> to our
Terms of Service and Privacy Policy
          </p>
          </div>
          {/* Submit */}
          <div className="flex flex-col bg-tradr-green  w-full mt-2  ">
          <Link className="btn-lg flex justify-center align-center   " to="/" >
          SIGN UP
          </Link>
    </div>
    {/* FORGOT PASSWORD */}
    <div className="flex  w-full mt-2  justify-between items-center ">
    <Link to="/reset-password" className="font-poppins font-medium text-gray text-tiny mb-2" >
    Forgot password?
    </Link>
    <Link to="/login" className="font-poppins font-medium text-gray text-tiny mb-2" >
      Login to your account
    </Link>
    </div>
    </div>
     </div>
     </div>
  )
}

export default Register